import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrSalesCheckoutService } from 'src/app/services/kn-br-sales-checkout.service';
import { MediaComponent } from '@spartacus/storefront';

@Component({
  selector: 'knbr-knbr-request-quote-confirmation',
  imports: [MediaComponent],
  templateUrl: './knbr-request-quote-confirmation.component.html',
    styleUrl: './knbr-request-quote-confirmation.component.scss',
    providers: [DatePipe],
})
export class KnbrRequestQuoteConfirmationComponent {
 orderConfirmationData: any

    constructor(private KnBrCheckoutService: KnBrSalesCheckoutService,
        private router: Router,
        private knBrCommonService: KnBrCommonService,
        private datePipe: DatePipe) {}

    ngOnInit(): void {
        const data: any = this.KnBrCheckoutService.getOrderConfirmData();
        this.orderConfirmationData = data;
        if (!this.orderConfirmationData) {
            this.gotoQuotes();
        }
    }

    gotoQuotes() {
        this.router.navigateByUrl('/quoteRequests');
    }

    // ✓ Format phone number for display
    getFormattedPhone(): string {
        const phone = this.orderConfirmationData?.deliveryAddress?.phone;
        if (!phone) return '-';
        return this.knBrCommonService.formatPhoneNumber(phone);
    }

    formatRequestDate(value: any): string {
        if (!value) {
            return '';
        }
        return this.datePipe.transform(value, 'MMMM d, y') || String(value);
    }


    getUploadedFiles(): any[] {
        const files =
            this.orderConfirmationData?.uploadedFiles ||
            this.orderConfirmationData?.files ||
            this.orderConfirmationData?.attachments ||
            this.orderConfirmationData?.deliveryAddress?.uploadedFiles ||
            this.orderConfirmationData?.deliveryAddress?.files ||
            [];

        return Array.isArray(files) ? files : [];
    }

    resolveImageUrl(item: any): string {
        return this.KnBrCheckoutService.resolveImageUrl(item);
    }

}
